// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5k-0";
export var startPickingButton = "_5k-1";